import { render, staticRenderFns } from "./pdfView.vue?vue&type=template&id=96bb740c&scoped=true&"
import script from "./pdfView.vue?vue&type=script&lang=js&"
export * from "./pdfView.vue?vue&type=script&lang=js&"
import style0 from "./pdfView.vue?vue&type=style&index=0&id=96bb740c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bb740c",
  null
  
)

export default component.exports